
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import AreaSelect from "@/components/scope/area-select.vue";
import StepList from "@/components/scope/step-list.vue";
import { emptyToLine, splitThousands, numDateToDate } from "@common/src/utils/common";
import dayjs from "dayjs";
import { addCurrencyUnit, permitCountry } from "@common/src/utils/tools";
import { Table } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
const customer = namespace("customer");
const marketing = namespace("marketing");
const common_app = namespace("common_app");

@Component({
  components: { AreaSelect, StepList, CustomerFlag }
})
@Table("loadListData")
export default class CustomerView extends Vue {
  @customer.Action getCustomerDetail;
  @customer.Action getCustomerExpensesRecord;
  @marketing.Action queryCardList;
  @common_app.State country;
  dayjs = dayjs;
  cardList: any[] = [];
  splitThousands = splitThousands;
  numDateToDate = numDateToDate;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  permitCountry = permitCountry;
  get breadData() {
    return [
      { name: t("test.customer-information"), path: "/setting/customer" },
      { name: t("setting.view-customer-information") }
    ];
  }
  customerData: any = {
    vehicle: {}
  };
  vehicleCode: any = "";
  vehicleList: any[] = [];
  expenseRecordList: any[] = []; //消费记录
  expenseTotalAmount: string = ""; // 消费总额
  expenseRecordListTotal: number = 0; // 消费记录总条数
  created() {
    this.init();
    this.queryExpenseList();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryCardList({
      // firstName: this.customerData.customerName,
      customerCode: this.customerData.customerCode,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.cardList = data.data.list;
      return data;
    });
  }
  async init() {
    this.vehicleCode = this.$route.query.vehicleCode;
    this.getCustomerDetail({
      customerCode: this.$route.params.id,
      vehicleCode: this.$route.query.vehicleCode
    }).then(data => {
      let tempArr = [];
      if (data.data.vehicleList && data.data.vehicleList.length > 0) {
        data.data.vehicleList.forEach(item => {
          if (this.vehicleCode === item.vehicleCode) {
            this.customerData = Object.assign({}, data.data, {
              vehicle: item
            });
            this.loadListData();
          } else {
            tempArr.push(item);
          }
        });
        this.vehicleList = tempArr;
      } else {
        this.customerData = Object.assign({}, data.data, {
          vehicle: {}
        });
      }
    });
  }
  handleLinkView(data) {
    this.$router.push(`/service/view/${data.orderNo}`);
  }
  recordPageNum: number = 1;
  queryExpenseList() {
    this.getCustomerExpensesRecord({
      pageNum: this.recordPageNum,
      pageSize: 3,
      vehicleCode: this.$route.query.vehicleCode
    }).then(data => {
      console.log(data);
      this.expenseRecordList.push(...data.data.list);
      this.expenseTotalAmount = data.data.totalAmount;
      this.expenseRecordListTotal = data.data.count;
    });
  }
  handleRecordMore() {
    this.recordPageNum++;
    this.queryExpenseList();
  }
  handleLinkChangeOwner() {
    let { href } = this.$router.resolve(
      `/setting/customer-edit/${this.$route.params.id}?vehicleCode=${this.vehicleCode}&changeOwner=1`
    );
    window.open(href, "_blank");
  }
  handleViewOther(vehicle) {
    let { href } = this.$router.resolve({
      path: `/setting/customer-view/${this.$route.params.id}?vehicleCode=${vehicle.vehicleCode}`
    });
    window.open(href, "_blank");
  }
  handleOpenOrder(url, row) {
    let { href } = this.$router.resolve(
      `${url}${url.includes("?") ? "&" : "?"}customerCode=${row.customerCode}&vehicleCode=${row.vehicle.vehicleCode}`
    );
    window.open(href);
  }
}
